import { STATUSES, validStatuses } from '#server/middleware/status-validators';
import axios, { AxiosRequestConfig } from 'axios';
import { retry, throttle } from '#server/shared/api';

const BASE_URL = `${process.env.API_BASE_URL || ''}/api`;

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
  withCredentials: true,
});

export const state = {
  clientId: null as string | null,
};

api.interceptors.request.use((config) => {
  config.headers['ws-client-id'] = <string>state.clientId;
  return config;
});

function setClientId(clientId: string) {
  state.clientId = clientId;
}

function getAll<T>(
  url: string,
  options: AxiosRequestConfig,
  onResponse: (data: T, status: number) => Promise<void> | void
): Promise<void> {
  async function getRequest(cursor = '') {
    const nextUrl = new URL(`${BASE_URL}${url}`);

    if (cursor) {
      const params = nextUrl.searchParams;
      params.append('cursor', cursor);
      nextUrl.search = `?${params.toString()}`;
    }

    const { data, status } = await api.get<T & { cursor: string }>(nextUrl.toString(), {
      headers: {
        ...options.headers,
      },
      validateStatus: validStatuses(STATUSES.NOT_FOUND),
    });
    await onResponse(data, status);

    if (data.cursor) {
      await getRequest(data.cursor);
    }
  }
  return new Promise((resolve, reject) => {
    void getRequest()
      .then(() => {
        resolve();
      })
      .catch(reject);
  });
}

retry(api);

throttle(api, isLimited);

function isLimited(url?: string) {
  return /\/(device|user)\/[^\./]+$/i.test(url || '');
}

export { api, getAll, setClientId };
